import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { apiUrl } from '@dashboard/services/env';
import request, { fetcher } from '@dashboard/services/request';

/**
 * @param {Object}
 */
async function updatePassword(token, values, userId) {
  try {
    const response = await request(`${apiUrl}/users/${userId}/update-password`, token, {
      body: JSON.stringify(values),
      method: 'POST',
    });

    if (!response) {
      throw new Error();
    }

    if (response?.status === 'error') {
      return { error: response };
    }

    return { data: null };
  } catch (error) {
    if (error?.message) {
      return { error: error.message };
    }

    return { error: 'Unable to update password' };
  }
}

export const updateUser = async (token, values, userId) => {
  try {
    const response = await request(apiUrl + `/user/${userId}`, token, {
      body: JSON.stringify(values),
      method: 'POST',
    });

    if (!response) {
      throw new Error();
    }

    if (response?.status === 'error') {
      return { error: response };
    }

    return { data: response.data, error: null };
  } catch (error) {
    if (error && error.message) {
      return { error: error.message };
    }

    return { error: 'Unable to save user', data: null };
  }
};

export function acceptInvite({ session, invite }) {
  return fetcher(`/accept-invite`, null, {
    method: 'POST',
    body: JSON.stringify({
      session,
      invite,
    }),
  });
}

export default function useUserQueries() {
  const { userId, token } = useAuth();

  return {
    updatePassword: values => updatePassword(token, values, userId),
    updateUser: (values, userId) => updateUser(token, values, userId),
    acceptInvite: ({ session, invite }) => acceptInvite({ session, invite }),
  };
}
